<!-- DZI are large images, so if you click on an image (or preview one from Explorer) it's the dialog 
  that comes up where you can pan/tilt/zoom around the image -->

<h5 *ngIf="canMark">
    {{'DIALOG.MARK_REFERENCE_TITLE' | translate: {
    id: mapService.selectedReference.referenceAnnotation.imageName,
    imagename: data.img.name.replace('THUMB', '').trim()
  }
    }}
  </h5>
  
  <div class="float-right" *ngIf="data && data.img">
      <table style="font-size:10px;">
          <tr> 

            <!-- File name -->
            <td class="fdm-metadata-header">{{'DIALOG.FILE_NAME' | translate }}</td>   
            <td class="fdm-metadata-answer">{{ data.img.ds_name }}</td>

            <!-- Date photo created -->
            <td class="fdm-metadata-header">{{'GENERIC.CREATED' | translate }}</td>   
            <td class="fdm-metadata-answer">{{ data.img.dateMade | dateAgo | async }}</td></tr>
          <tr> 

            <!-- Photo dimensions-->
            <td *ngIf="data.img.dimensions" class="fdm-metadata-header">{{'DIALOG.DIMENSIONS' | translate }}</td>   
            <td *ngIf="data.img.dimensions" class="fdm-metadata-answer">{{ data.img.dimensions.width }} x {{ data.img.dimensions.height }}</td>
            
            <!-- Heading, pitch and roll: essentially the angles of the XYZ axis of the 
              camera when the picture was taken (compass, rolling axis and angle up/down) -->
            <td *ngIf="data.img.exif_hpr" class="fdm-metadata-header">{{'DIALOG.CAMERA_ANGLES' | translate }}</td>   
            <td *ngIf="data.img.exif_hpr" class="fdm-metadata-answer">{{ data.img.exif_hpr.heading }}, {{ data.img.exif_hpr.pitch }}, {{ data.img.exif_hpr.roll }}</td></tr>
          
      </table>
  </div>

  <h1 *ngIf="!canMark"  style="margin-bottom:0;" mat-dialog-title>{{data.title | translate:transform }}</h1>
  <ng-container *ngIf="viewer">

    <!-- Max zoom level -->
    <span *ngFor="let item of ['maxZoomPixelRatio']; let i = index;" style="font-size:11px;">
      {{'DIALOG.MAX_ZOOM' | translate }} {{ viewer[item] }}
      <mat-slider color="primary" class="fdm-layer-slider" min="1" max="10" step="0.5" style="width:100px;"
      [(ngModel)]="viewer[item]"
      (input)="update(item,$event.value);"
      thumbLabel="true"
      ></mat-slider>
    </span>
  </ng-container>

  <mat-progress-bar diameter="20" *ngIf="!dziOpen && !errorInApplyTransform"
                    mode="indeterminate">
  </mat-progress-bar>
  <h4 *ngIf="!dziOpen && !errorInApplyTransform"><br> {{'DIALOG.ZOOM_LEVEL' | translate }} </h4>

  <img [hidden]="!showOverLay" id="right-arrow-overlay"
       src="data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJ0YWdzIiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgaGVpZ2h0PSIzMCIgd2lkdGg9IjMwIiB2aWV3Qm94PSIwIDAgNjQwIDUxNyI+PHBhdGggZmlsbD0icmVkIiBkPSJNNTAwIDIyNGgtMzAuMzY0QzQ1NS43MjQgMTMwLjMyNSAzODEuNjc1IDU2LjI3NiAyODggNDIuMzY0VjEyYzAtNi42MjctNS4zNzMtMTItMTItMTJoLTQwYy02LjYyNyAwLTEyIDUuMzczLTEyIDEydjMwLjM2NEMxMzAuMzI1IDU2LjI3NiA1Ni4yNzYgMTMwLjMyNSA0Mi4zNjQgMjI0SDEyYy02LjYyNyAwLTEyIDUuMzczLTEyIDEydjQwYzAgNi42MjcgNS4zNzMgMTIgMTIgMTJoMzAuMzY0QzU2LjI3NiAzODEuNjc1IDEzMC4zMjUgNDU1LjcyNCAyMjQgNDY5LjYzNlY1MDBjMCA2LjYyNyA1LjM3MyAxMiAxMiAxMmg0MGM2LjYyNyAwIDEyLTUuMzczIDEyLTEydi0zMC4zNjRDMzgxLjY3NSA0NTUuNzI0IDQ1NS43MjQgMzgxLjY3NSA0NjkuNjM2IDI4OEg1MDBjNi42MjcgMCAxMi01LjM3MyAxMi0xMnYtNDBjMC02LjYyNy01LjM3My0xMi0xMi0xMnpNMjg4IDQwNC42MzRWMzY0YzAtNi42MjctNS4zNzMtMTItMTItMTJoLTQwYy02LjYyNyAwLTEyIDUuMzczLTEyIDEydjQwLjYzNEMxNjUuODI2IDM5Mi4yMzIgMTE5Ljc4MyAzNDYuMjQzIDEwNy4zNjYgMjg4SDE0OGM2LjYyNyAwIDEyLTUuMzczIDEyLTEydi00MGMwLTYuNjI3LTUuMzczLTEyLTEyLTEyaC00MC42MzRDMTE5Ljc2OCAxNjUuODI2IDE2NS43NTcgMTE5Ljc4MyAyMjQgMTA3LjM2NlYxNDhjMCA2LjYyNyA1LjM3MyAxMiAxMiAxMmg0MGM2LjYyNyAwIDEyLTUuMzczIDEyLTEydi00MC42MzRDMzQ2LjE3NCAxMTkuNzY4IDM5Mi4yMTcgMTY1Ljc1NyA0MDQuNjM0IDIyNEgzNjRjLTYuNjI3IDAtMTIgNS4zNzMtMTIgMTJ2NDBjMCA2LjYyNyA1LjM3MyAxMiAxMiAxMmg0MC42MzRDMzkyLjIzMiAzNDYuMTc0IDM0Ni4yNDMgMzkyLjIxNyAyODggNDA0LjYzNHpNMjg4IDI1NmMwIDE3LjY3My0xNC4zMjcgMzItMzIgMzJzLTMyLTE0LjMyNy0zMi0zMmMwLTE3LjY3MyAxNC4zMjctMzIgMzItMzJzMzIgMTQuMzI3IDMyIDMyeiI+PC9wYXRoPjwvc3ZnPg=="
       alt="Right arrow"
       width="20">

       <div class="clearfix"></div>
  <div mat-dialog-content [hidden]="!dziOpen" id="dragon" style="height:85%; max-height: max-content;">

  </div>
  
  <div mat-dialog-actions class="align-content-right">
    <mat-progress-spinner diameter="20" *ngIf="capturing"
                          mode="indeterminate"
    ></mat-progress-spinner>


    <button *ngIf="data.negBtn" color="primary" mat-button style="bottom:10%;right: 20%;position: absolute;"
            (click)="cnx()" translate>
      {{data.negBtn | translate:transform}}
    </button>

    <button [disabled]="capturing" *ngIf="showCaptureButton && dziOpen" color="primary" mat-button
            (click)="captureScrenShot()"> <!--style="bottom:10%;right: 14%;position: absolute;"-->
      {{"GENERIC.SCREENSHOT" | translate }}
    </button>
    
    <button [disabled]="" *ngIf="canMark && dziOpen" color="primary" mat-button
            (click)="mark()"> <!--style="bottom:10%;right: 14%;position: absolute;"-->
      {{"DIALOG.MARK" | translate }}
    </button>

    <button *ngIf="canClearMark && dziOpen" color="primary" mat-button
            (click)="clearMark()"> <!--style="bottom:10%;right: 14%;position: absolute;"-->
      {{"DIALOG.CLEAR_MARK" | translate }}
    </button>

    <!-- Close DZI preview -->
    <button color="primary" mat-button (click)="cnx()"> <!--style="bottom:10%;right: 10%;position: absolute;"-->
      {{(data.posBtn ? data.posBtn : "GENERIC.CLOSE") | translate:transform}}
    </button>
  </div>